/* Wishifyy V2 - Reviews page behaviors:
   - Fetch stats + reviews from worker
   - Bucket reviews into 3 tiers: photos (carousel) → text (grid) → star-only (compact)
   - Auto-rotating photo carousel (prev/next + dots)
   - Filter chips (All / 5★ / 4★)
   - Load more
   - Write-review modal: rating selector, photo upload preview, AJAX submit
   - On success with photo: discount code (copy-on-click)
*/
(function () {
  'use strict';

  function escapeHtml(s) {
    if (!s) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  /* Helpful votes - localStorage-deduped, threshold 1 */
  function rv2HelpfulToken() {
    try {
      var t = localStorage.getItem('rv2-helpful-token');
      if (t && t.length >= 8) return t;
      t = 'h_' + Math.random().toString(36).slice(2, 10) + '_' + Date.now().toString(36);
      localStorage.setItem('rv2-helpful-token', t);
      return t;
    } catch (e) { return 'h_anon_' + Math.random().toString(36).slice(2, 14); }
  }
  function rv2HasVoted(reviewId) {
    try {
      var v = JSON.parse(localStorage.getItem('rv2-helpful-voted') || '{}');
      return !!v[reviewId];
    } catch (e) { return false; }
  }
  function rv2MarkVoted(reviewId) {
    try {
      var v = JSON.parse(localStorage.getItem('rv2-helpful-voted') || '{}');
      v[reviewId] = 1;
      localStorage.setItem('rv2-helpful-voted', JSON.stringify(v));
    } catch (e) {}
  }
  function helpfulCountText(n) {
    return n + (n === 1 ? ' човек смята това за полезно' : ' човека сметнаха това за полезно');
  }
  function helpfulButtonHtml(reviewId) {
    if (!reviewId) return '';
    var voted = rv2HasVoted(reviewId);
    var safeId = String(reviewId).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
    return '<div class="rv2__helpful" data-rv2-helpful="' + safeId + '">' +
      '<button type="button" class="rv2__helpful-btn' + (voted ? ' is-voted' : '') + '" data-rv2-helpful-btn aria-label="Полезно ревю">' +
        '<span class="rv2__helpful-thumb" aria-hidden="true">👍</span>' +
        '<span class="rv2__helpful-label">' + (voted ? 'Благодарим!' : 'Полезно') + '</span>' +
      '</button>' +
      '<span class="rv2__helpful-count" data-rv2-helpful-count hidden></span>' +
    '</div>';
  }
  function cssEscapeId(s) { return String(s).replace(/(["\\])/g, '\\$1'); }
  function hydrateHelpfulCounts(rv2Root) {
    var ids = [];
    rv2Root.querySelectorAll('[data-rv2-helpful]').forEach(function (el) {
      var id = el.getAttribute('data-rv2-helpful');
      if (id && ids.indexOf(id) < 0) ids.push(id);
    });
    if (!ids.length) return;
    var workerBase = rv2Root.dataset.workerBase || 'https://wishifyy-crm.wishifycom.workers.dev';
    fetch(workerBase + '/api/public/reviews/helpful?ids=' + encodeURIComponent(ids.join(',')))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.counts) return;
        Object.keys(d.counts).forEach(function (rid) {
          var n = Number(d.counts[rid] || 0);
          if (n < 1) return;
          rv2Root.querySelectorAll('[data-rv2-helpful="' + cssEscapeId(rid) + '"]').forEach(function (box) {
            var cEl = box.querySelector('[data-rv2-helpful-count]');
            if (cEl) { cEl.textContent = helpfulCountText(n); cEl.removeAttribute('hidden'); }
          });
        });
      })
      .catch(function () {});
  }


  /* Expose helpers to IIFE #2 (renderDetail / initDetail are in separate scope) */
  try {
    window.__rv2HelpfulToken = rv2HelpfulToken;
    window.__rv2HasVoted = rv2HasVoted;
    window.__rv2MarkVoted = rv2MarkVoted;
    window.__helpfulCountText = helpfulCountText;
    window.__helpfulButtonHtml = helpfulButtonHtml;
    window.__cssEscapeId = cssEscapeId;
  } catch (e) {}

  function starsHtml(rating) {
    var full = Math.round(rating);
    var html = '';
    for (var i = 1; i <= 5; i++) html += i <= full ? '★' : '<span class="rv2__card-stars-empty">★</span>';
    return html;
  }

  function formatDate(iso) {
    try {
      return new Date(iso).toLocaleDateString('bg-BG', { year: 'numeric', month: 'long', day: 'numeric' });
    } catch (e) { return ''; }
  }

  function hasMedia(r) {
    return (r.videos && r.videos.length > 0) || (r.pictures && r.pictures.length > 0);
  }

  function bucketize(reviews) {
    var photos = [], text = [], stars = [];
    reviews.forEach(function (r) {
      var bodyLen = (r.body || '').trim().length;
      var titleLen = (r.title || '').trim().length;
      // ANY meaningful text content (title OR body, ≥3 chars combined) belongs in the text tier.
      // Stars-only is reserved for reviews that truly have no comment - just a rating.
      var hasText = (bodyLen + titleLen) >= 3;
      // "photos" tier = reviews with visual media (videos OR pictures).
      if (hasMedia(r)) photos.push(r);
      else if (hasText) text.push(r);
      else stars.push(r);
    });
    // Videos render BEFORE photos in the media carousel + gallery.
    photos.sort(function (a, b) {
      var av = (a.videos && a.videos.length > 0) ? 0 : 1;
      var bv = (b.videos && b.videos.length > 0) ? 0 : 1;
      return av - bv;
    });
    return { photos: photos, text: text, stars: stars };
  }

  function init(rv2) {
    var workerBase = rv2.dataset.workerBase || '';
    if (!workerBase) { console.warn('[rv2] no worker base'); return; }

    // Refs
    var skeletonEl = rv2.querySelector('[data-rv2-skeleton]');
    var loadMoreEl = rv2.querySelector('[data-rv2-loadmore]');
    var loadMoreBtn = rv2.querySelector('[data-rv2-loadmore-btn]');
    var emptyEl = rv2.querySelector('[data-rv2-empty]');
    var statsEl = rv2.querySelector('[data-rv2-stats]');
    var avgEl = rv2.querySelector('[data-rv2-avg]');
    var avgStarsEl = rv2.querySelector('[data-rv2-avg-stars]');
    var totalEl = rv2.querySelector('[data-rv2-total]');
    var withPicsEl = rv2.querySelector('[data-rv2-with-pics]');
    var filterBtns = rv2.querySelectorAll('[data-rv2-filter]');

    var tierPhotos = rv2.querySelector('[data-rv2-tier-photos]');
    var tierText = rv2.querySelector('[data-rv2-tier-text]');
    var tierStars = rv2.querySelector('[data-rv2-tier-stars]');
    var carouselTrack = rv2.querySelector('[data-rv2-carousel-track]');
    var carouselDots = rv2.querySelector('[data-rv2-carousel-dots]');
    var carouselPrev = rv2.querySelector('[data-rv2-carousel-prev]');
    var carouselNext = rv2.querySelector('[data-rv2-carousel-next]');
    var listText = rv2.querySelector('[data-rv2-list-text]');
    var listStars = rv2.querySelector('[data-rv2-list-stars]');

    var carouselWrapEl = rv2.querySelector('[data-rv2-carousel]');
    var carouselMax = parseInt(rv2.querySelector('[data-rv2-tier-photos]')?.dataset?.carouselMax || '12') || 12;
    var inlineCap = parseInt(rv2.dataset.rv2InlineCap || '4') || 4;
    var starsInitial = parseInt(rv2.dataset.rv2StarsInitial || '8') || 8;
    var starsStep = parseInt(rv2.dataset.rv2StarsStep || '8') || 8;
    var textInitial = parseInt(rv2.dataset.rv2TextInitial || '4') || 4;
    var textStep = parseInt(rv2.dataset.rv2TextStep || '4') || 4;
    var modalInitial = parseInt(rv2.dataset.rv2ModalInitial || '12') || 12;
    var modalStep = parseInt(rv2.dataset.rv2ModalStep || '12') || 12;
    var isCompact = rv2.classList.contains('rv2--compact');
    var state = {
      filter: 'all',
      page: 1,
      perPage: 24,
      loading: false,
      hasMore: false,
      allReviews: [],
      carouselIndex: 0,
      carouselTimer: null,
      carouselSpeed: parseInt(carouselWrapEl?.dataset?.autoplaySpeed || '6') * 1000,
      carouselMax: carouselMax,
      inlineCap: inlineCap,
      starsVisible: starsInitial,
      starsStep: starsStep,
      textVisible: textInitial,
      textStep: textStep,
      modalMode: 'all',
      modalVisible: modalInitial,
      modalStep: modalStep,
    };
    /* Expose for the detail-modal handler at the bottom of this file */
    window.__rv2State = window.__rv2State || {};
    window.__rv2State[rv2.id || rv2.dataset.rv2Sid || 'default'] = state;

    // View-all CTA + reviews modal refs
    var viewallEl = rv2.querySelector('[data-rv2-viewall]');
    var viewallBtn = rv2.querySelector('[data-rv2-viewall-open]');
    var viewallCount = rv2.querySelector('[data-rv2-viewall-count]');
    var reviewsModal = rv2.querySelector('[data-rv2-reviews-modal]');
    var reviewsModalCloseEls = rv2.querySelectorAll('[data-rv2-reviews-modal-close]');
    var reviewsGridEl = rv2.querySelector('[data-rv2-reviews-grid]');
    var reviewsLoadmoreEl = rv2.querySelector('[data-rv2-reviews-loadmore]');
    var reviewsLoadmoreBtn = rv2.querySelector('[data-rv2-reviews-loadmore-btn]');
    var reviewsEmptyEl = rv2.querySelector('[data-rv2-reviews-empty]');
    var reviewsLoadingEl = rv2.querySelector('[data-rv2-reviews-loading]');

    // Stars-tier per-tier load-more refs (full mode only)
    var starsMoreEl = rv2.querySelector('[data-rv2-stars-more]');
    var starsMoreBtn = rv2.querySelector('[data-rv2-stars-more-btn]');
    var starsMoreCount = rv2.querySelector('[data-rv2-stars-more-count]');

    // Text-tier per-tier load-more refs (full mode only)
    var textMoreEl = rv2.querySelector('[data-rv2-text-more]');
    var textMoreBtn = rv2.querySelector('[data-rv2-text-more-btn]');
    var textMoreCount = rv2.querySelector('[data-rv2-text-more-count]');

    // Photos modal refs
    var photosModal = rv2.querySelector('[data-rv2-photos-modal]');
    var photosModalCloseEls = rv2.querySelectorAll('[data-rv2-photos-modal-close]');
    var photosGrid = rv2.querySelector('[data-rv2-photos-grid]');
    var photosLoadmoreEl = rv2.querySelector('[data-rv2-photos-loadmore]');
    var photosLoadmoreBtn = rv2.querySelector('[data-rv2-photos-loadmore-btn]');
    var photosEmptyEl = rv2.querySelector('[data-rv2-photos-empty]');

    var productHandle = rv2.dataset.rv2ProductHandle || '';
    var allowTopUp = rv2.dataset.rv2AllowTopUp !== 'false';
    var topUpThreshold = parseInt(rv2.dataset.rv2TopUpThreshold || '5');

    function buildListUrl() {
      var u = new URL(workerBase + '/api/public/reviews/list');
      u.searchParams.set('per_page', state.perPage);
      u.searchParams.set('page', state.page);
      if (state.filter === '5') u.searchParams.set('rating', '5');
      else if (state.filter === '4') u.searchParams.set('rating', '4');
      if (productHandle) {
        u.searchParams.set('product_handle', productHandle);
        if (allowTopUp) {
          u.searchParams.set('allow_top_up', 'true');
          u.searchParams.set('top_up_threshold', String(topUpThreshold));
        }
      }
      return u.toString();
    }

    /* ────── Card renderers ────── */

    function verifiedBadgeHtml(verified) {
      if (!verified) return '';
      return '<span class="rv2__card-verified" title="Реално потвърдена покупка"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><path d="M20 6L9 17l-5-5"/></svg>Купувач</span>';
    }

    function productLinkHtml(r) {
      if (!r.product_handle || r.product_handle === 'judgeme-shop-reviews') return '';
      return '<span class="rv2__card-product">за <a href="/products/' + escapeHtml(r.product_handle) + '">' + escapeHtml(r.product_title || r.product_handle) + '</a></span>';
    }

    function appendCarouselDot(i, isCta) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'rv2-carousel__dot' + (isCta ? ' rv2-carousel__dot--cta' : '');
      dot.setAttribute('data-rv2-dot', String(i));
      dot.setAttribute('aria-label', isCta ? 'Виж всички' : 'Слайд ' + (i + 1));
      dot.addEventListener('click', function () { setActiveSlide(i); startCarouselAutoplay(); });
      carouselDots.appendChild(dot);
    }

    function renderViewAllSlide(totalPhotos, shownCount) {
      var slide = document.createElement('div');
      slide.className = 'rv2-carousel__slide rv2-carousel__slide--cta';
      var ctaLabel = (rv2.querySelector('[data-rv2-tier-photos]')?.dataset?.viewAllCta) || 'Виж всички снимки';
      slide.innerHTML =
        '<div class="rv2-carousel__cta-inner">' +
          '<div class="rv2-carousel__cta-count">+' + (totalPhotos - shownCount) + '</div>' +
          '<p class="rv2-carousel__cta-text">още снимки от клиенти. Виж цялата галерия.</p>' +
          '<button type="button" data-rv2-open-photos-modal>' +
            '<span>' + escapeHtml(ctaLabel) + '</span>' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><path d="M5 12h14M13 6l6 6-6 6"/></svg>' +
          '</button>' +
        '</div>';
      slide.querySelector('[data-rv2-open-photos-modal]').addEventListener('click', openPhotosModal);
      return slide;
    }

    function renderCarouselSlide(r, idx, total) {
      var slide = document.createElement('div');
      slide.className = 'rv2-carousel__slide';
      slide.setAttribute('data-rv2-slide-idx', String(idx));
      if (r.id) slide.setAttribute('data-rv-id', r.id);
      // Video-first: prefer the first video's poster (or video itself) as the carousel thumbnail.
      // Falls back to first picture if no video. Click anywhere on the slide still opens the detail modal.
      var firstVid = r.videos && r.videos[0];
      var firstPic = r.pictures && r.pictures[0];
      var mediaHtml;
      if (firstVid) {
        // Perf: render the poster as an <img> (one ~50KB request) instead of a <video> tag.
        // The <video> tag, even with preload="none", costs an HTTP HEAD request and reserves a media element slot.
        // Actual video plays only inside the detail modal, on user click → zero video bytes on page load.
        if (firstVid.poster) {
          mediaHtml = '<img class="rv2-carousel__video-poster" src="' + escapeHtml(firstVid.poster) + '" alt="" loading="lazy">';
        } else {
          // No poster yet (Shopify transcoding still in progress) - fall back to <video preload="none">.
          mediaHtml = '<video class="rv2-carousel__video" preload="none" muted playsinline>' +
            '<source src="' + escapeHtml(firstVid.url) + '#t=0.1" type="video/mp4">' +
          '</video>';
        }
        mediaHtml +=
          '<span class="rv2-carousel__media-play" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" fill="currentColor" width="42" height="42"><path d="M8 5v14l11-7z"/></svg>' +
          '</span>';
      } else if (firstPic) {
        mediaHtml = '<img src="' + escapeHtml(firstPic.full || firstPic.thumb) + '" alt="" loading="lazy">';
      } else {
        mediaHtml = '';
      }
      slide.innerHTML =
        '<div class="rv2-carousel__media">' +
          mediaHtml +
          '<span class="rv2-carousel__media-pager">' + (idx + 1) + ' / ' + total + '</span>' +
        '</div>' +
        '<div class="rv2-carousel__body">' +
          '<div class="rv2__card-head">' +
            '<span class="rv2__card-stars">' + starsHtml(r.rating) + '</span>' +
            verifiedBadgeHtml(r.verified) +
          '</div>' +
          (r.title ? '<h3 class="rv2__card-title">' + escapeHtml(r.title) + '</h3>' : '') +
          '<p class="rv2__card-text">' + escapeHtml(r.body) + '</p>' +
          '<div class="rv2__card-meta">' +
            '<span class="rv2__card-author">' + escapeHtml(r.reviewer_name) + ' · ' + formatDate(r.created_at) + '</span>' +
            productLinkHtml(r) +
          '</div>' +
          helpfulButtonHtml(r.id) +
        '</div>';
      return slide;
    }

    function renderTextCard(r) {
      var li = document.createElement('li');
      li.className = 'rv2__card';
      if (r.id) li.setAttribute('data-rv-id', r.id);
      li.innerHTML =
        '<div class="rv2__card-head">' +
          '<span class="rv2__card-stars">' + starsHtml(r.rating) + '</span>' +
          verifiedBadgeHtml(r.verified) +
        '</div>' +
        (r.title ? '<h3 class="rv2__card-title">' + escapeHtml(r.title) + '</h3>' : '') +
        '<p class="rv2__card-body">' + escapeHtml(r.body) + '</p>' +
        '<div class="rv2__card-meta">' +
          '<span class="rv2__card-author">' + escapeHtml(r.reviewer_name) + ' · ' + formatDate(r.created_at) + '</span>' +
          productLinkHtml(r) +
        '</div>' +
        helpfulButtonHtml(r.id);
      return li;
    }

    function renderStarOnlyCard(r) {
      var li = document.createElement('li');
      li.className = 'rv2__card';
      if (r.id) li.setAttribute('data-rv-id', r.id);
      li.innerHTML =
        '<span class="rv2__card-stars">' + starsHtml(r.rating) + '</span>' +
        '<div class="rv2__card-meta">' +
          '<span class="rv2__card-author">' + escapeHtml(r.reviewer_name) + '</span>' +
          '<span>' + formatDate(r.created_at) + '</span>' +
        '</div>';
      return li;
    }

    /* ────── Carousel control ────── */

    function setActiveSlide(newIndex) {
      var slides = carouselTrack.querySelectorAll('.rv2-carousel__slide');
      if (slides.length === 0) return;
      var idx = ((newIndex % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      carouselDots.querySelectorAll('.rv2-carousel__dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
      state.carouselIndex = idx;
    }

    function startCarouselAutoplay() {
      stopCarouselAutoplay();
      var slides = carouselTrack.querySelectorAll('.rv2-carousel__slide');
      if (slides.length <= 1) return;
      state.carouselTimer = setInterval(function () {
        setActiveSlide(state.carouselIndex + 1);
      }, state.carouselSpeed);
    }

    function stopCarouselAutoplay() {
      if (state.carouselTimer) {
        clearInterval(state.carouselTimer);
        state.carouselTimer = null;
      }
    }

    if (carouselPrev) carouselPrev.addEventListener('click', function () { setActiveSlide(state.carouselIndex - 1); startCarouselAutoplay(); });
    if (carouselNext) carouselNext.addEventListener('click', function () { setActiveSlide(state.carouselIndex + 1); startCarouselAutoplay(); });
    var carouselWrap = rv2.querySelector('[data-rv2-carousel]');
    if (carouselWrap) {
      carouselWrap.addEventListener('mouseenter', stopCarouselAutoplay);
      carouselWrap.addEventListener('mouseleave', startCarouselAutoplay);

      /* Touch swipe - mobile users swipe horizontally to advance photo slides */
      var rv2TouchStartX = 0;
      var rv2TouchStartY = 0;
      var rv2TouchActive = false;
      carouselWrap.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        rv2TouchStartX = e.touches[0].clientX;
        rv2TouchStartY = e.touches[0].clientY;
        rv2TouchActive = true;
        stopCarouselAutoplay();
      }, { passive: true });
      carouselWrap.addEventListener('touchmove', function (e) {
        if (!rv2TouchActive || !e.touches || e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - rv2TouchStartX;
        var dy = e.touches[0].clientY - rv2TouchStartY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8 && e.cancelable) {
          e.preventDefault();
        }
      }, { passive: false });
      carouselWrap.addEventListener('touchend', function (e) {
        if (!rv2TouchActive) return;
        rv2TouchActive = false;
        var endX = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : rv2TouchStartX;
        var endY = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientY : rv2TouchStartY;
        var dx = endX - rv2TouchStartX;
        var dy = endY - rv2TouchStartY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          setActiveSlide(state.carouselIndex + (dx < 0 ? 1 : -1));
        }
        startCarouselAutoplay();
      }, { passive: true });
      carouselWrap.addEventListener('touchcancel', function () {
        rv2TouchActive = false;
        startCarouselAutoplay();
      }, { passive: true });
    }

    /* ────── Render all tiers from current bucket ────── */

    function renderTiers(reviews) {
      var buckets = bucketize(reviews);
      var totalLoaded = reviews.length;
      var cap = state.inlineCap;
      // Inline distribution cap applies ONLY in compact mode (product page embed).
      // Full reviews page renders all 3 tiers; stars tier handles its own pagination via load-more.
      var inlineOverflow = isCompact && cap > 0 && totalLoaded > cap;

      // Inline cap distribution: prioritize photos (max 2) → text → stars
      if (inlineOverflow) {
        var photoLimit = Math.min(2, buckets.photos.length);
        var photoSlice = buckets.photos.slice(0, photoLimit);
        var remaining = cap - photoSlice.length;
        var textSlice = buckets.text.slice(0, Math.max(0, Math.min(remaining, buckets.text.length)));
        remaining -= textSlice.length;
        var starsSlice = buckets.stars.slice(0, Math.max(0, Math.min(remaining, buckets.stars.length)));
        buckets = { photos: photoSlice, text: textSlice, stars: starsSlice };
      }

      // Tier 1 - photos (cap at state.carouselMax slides; if more, last slide is "view all" CTA)
      carouselTrack.innerHTML = '';
      carouselDots.innerHTML = '';
      if (buckets.photos.length > 0) {
        var visiblePhotos = buckets.photos.slice(0, state.carouselMax);
        var hasMore = buckets.photos.length > state.carouselMax;
        var totalSlides = visiblePhotos.length + (hasMore ? 1 : 0);
        visiblePhotos.forEach(function (r, i) {
          carouselTrack.appendChild(renderCarouselSlide(r, i, totalSlides));
          appendCarouselDot(i);
        });
        if (hasMore) {
          var ctaSlide = renderViewAllSlide(buckets.photos.length, visiblePhotos.length);
          carouselTrack.appendChild(ctaSlide);
          appendCarouselDot(visiblePhotos.length, true);
        }
        setActiveSlide(0);
        startCarouselAutoplay();
        tierPhotos.removeAttribute('hidden');
      } else {
        stopCarouselAutoplay();
        tierPhotos.setAttribute('hidden', '');
      }

      // Tier 2 - text
      // - Compact mode: render all (already capped via inline distribution)
      // - Full mode: cap at state.textVisible; show per-tier "Виж всички" → opens modal
      listText.innerHTML = '';
      if (buckets.text.length > 0) {
        if (isCompact) {
          buckets.text.forEach(function (r) { listText.appendChild(renderTextCard(r)); });
          if (textMoreEl) textMoreEl.setAttribute('hidden', '');
        } else {
          var tVisible = state.textVisible;
          buckets.text.slice(0, tVisible).forEach(function (r) { listText.appendChild(renderTextCard(r)); });
          if (textMoreEl) {
            // Show "Виж всички" if there are MORE than what's visible inline OR more on server.
            var tTotal = buckets.text.length + (state.hasMore ? '+' : '');
            var tHasMore = buckets.text.length > tVisible || state.hasMore;
            if (tHasMore) {
              textMoreEl.removeAttribute('hidden');
              if (textMoreCount) textMoreCount.textContent = '(' + tTotal + ')';
            } else {
              textMoreEl.setAttribute('hidden', '');
            }
          }
        }
        tierText.removeAttribute('hidden');
      } else {
        tierText.setAttribute('hidden', '');
        if (textMoreEl) textMoreEl.setAttribute('hidden', '');
      }

      // Tier 3 - stars only
      // - Compact mode: render whatever's in buckets.stars (already capped by inline distribution)
      // - Full mode: cap at state.starsVisible; show per-tier "Виж всички" → opens modal
      listStars.innerHTML = '';
      if (buckets.stars.length > 0) {
        if (isCompact) {
          buckets.stars.forEach(function (r) { listStars.appendChild(renderStarOnlyCard(r)); });
          if (starsMoreEl) starsMoreEl.setAttribute('hidden', '');
        } else {
          var visible = state.starsVisible;
          buckets.stars.slice(0, visible).forEach(function (r) { listStars.appendChild(renderStarOnlyCard(r)); });
          if (starsMoreEl) {
            var sTotal = buckets.stars.length + (state.hasMore ? '+' : '');
            var sHasMore = buckets.stars.length > visible || state.hasMore;
            if (sHasMore) {
              starsMoreEl.removeAttribute('hidden');
              if (starsMoreCount) starsMoreCount.textContent = '(' + sTotal + ')';
            } else {
              starsMoreEl.setAttribute('hidden', '');
            }
          }
        }
        tierStars.removeAttribute('hidden');
      } else {
        tierStars.setAttribute('hidden', '');
        if (starsMoreEl) starsMoreEl.setAttribute('hidden', '');
      }

      /* Hydrate helpful-vote counts after main tier render */
      try { hydrateHelpfulCounts(rv2); } catch (e) {}

      var anyContent = buckets.photos.length + buckets.text.length + buckets.stars.length;
      if (anyContent === 0) emptyEl.removeAttribute('hidden');
      else emptyEl.setAttribute('hidden', '');

      // Sync the "Със снимка" stat with what's actually displayed.
      // Server's with_pictures count includes photo reviews that haven't been fetched yet -
      // if API per_page=24 has only 2 photos but server has 3 total, displaying "3" while showing
      // 2 in the carousel is dishonest. Use actual loaded photo count instead.
      if (withPicsEl) withPicsEl.textContent = String(bucketize(reviews).photos.length);

      // View-all CTA visibility - show when inline overflow OR when server has more pages
      // Compact only: full mode uses per-tier stars load-more instead of modal CTA.
      if (viewallEl) {
        var shouldShowCta = isCompact && (inlineOverflow || state.hasMore);
        if (shouldShowCta && totalLoaded > 0) {
          viewallEl.removeAttribute('hidden');
          if (viewallCount) {
            viewallCount.textContent = state.hasMore ? (totalLoaded + '+') : String(totalLoaded);
          }
          // Hide inline load-more - modal handles pagination
          if (loadMoreEl) loadMoreEl.setAttribute('hidden', '');
        } else {
          viewallEl.setAttribute('hidden', '');
        }
      }
      // Full mode: when any per-tier load-more is active it covers pagination - hide the global one.
      if (!isCompact) {
        var perTierActive =
          (starsMoreEl && !starsMoreEl.hasAttribute('hidden')) ||
          (textMoreEl && !textMoreEl.hasAttribute('hidden'));
        if (perTierActive && loadMoreEl) loadMoreEl.setAttribute('hidden', '');
      }
    }

    /* ────── Fetching ────── */

    function fetchStats() {
      var statsUrl = workerBase + '/api/public/reviews/stats';
      if (productHandle) {
        statsUrl += '?product_handle=' + encodeURIComponent(productHandle);
        if (allowTopUp) statsUrl += '&allow_top_up=true';
      }
      return fetch(statsUrl)
        .then(function (r) { return r.json(); })
        .then(function (s) {
          if (avgEl) avgEl.textContent = (s.avg_rating || 0).toFixed(2);
          if (avgStarsEl) avgStarsEl.innerHTML = starsHtml(s.avg_rating || 0);
          if (totalEl) totalEl.textContent = s.total || 0;
          // Don't write withPicsEl here - it's owned by renderTiers and reflects
          // the actually-displayed photo count (server total can be ahead of paginated data).
          if (statsEl) statsEl.removeAttribute('hidden');
        })
        .catch(function (e) { console.warn('[rv2] stats failed:', e); });
    }

    function fetchPage(reset) {
      if (state.loading) return Promise.resolve();
      if (reset) { state.page = 1; state.allReviews = []; }
      state.loading = true;

      if (loadMoreBtn) loadMoreBtn.setAttribute('aria-busy', 'true');
      if (reset) {
        if (skeletonEl) skeletonEl.removeAttribute('hidden');
        if (loadMoreEl) loadMoreEl.setAttribute('hidden', '');
        if (emptyEl) emptyEl.setAttribute('hidden', '');
        // Clear current tiers
        if (tierPhotos) tierPhotos.setAttribute('hidden', '');
        if (tierText) tierText.setAttribute('hidden', '');
        if (tierStars) tierStars.setAttribute('hidden', '');
      }

      return fetch(buildListUrl())
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var reviews = data.reviews || [];
          state.allReviews = state.allReviews.concat(reviews);
          if (reset && skeletonEl) skeletonEl.setAttribute('hidden', '');

          state.hasMore = reviews.length >= state.perPage;
          renderTiers(state.allReviews);

          // Global load-more only when no per-tier load-more is showing (or compact mode).
          if (loadMoreEl) {
            var perTierShown =
              (starsMoreEl && !starsMoreEl.hasAttribute('hidden')) ||
              (textMoreEl && !textMoreEl.hasAttribute('hidden'));
            var globalLoadmoreNeeded = state.hasMore && (isCompact || !perTierShown);
            if (globalLoadmoreNeeded) loadMoreEl.removeAttribute('hidden');
            else loadMoreEl.setAttribute('hidden', '');
          }
        })
        .catch(function (e) {
          console.error('[rv2] fetch failed:', e);
          if (reset && skeletonEl) skeletonEl.setAttribute('hidden', '');
          if (emptyEl) {
            emptyEl.textContent = 'Опа, не успяхме да заредим ревютата. Опитай по-късно.';
            emptyEl.removeAttribute('hidden');
          }
        })
        .finally(function () {
          state.loading = false;
          if (loadMoreBtn) loadMoreBtn.removeAttribute('aria-busy');
        });
    }

    /* ────── Filters ────── */

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.getAttribute('data-rv2-filter');
        if (f === state.filter) return;
        state.filter = f;
        filterBtns.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        fetchPage(true);
      });
    });
    var allBtn = rv2.querySelector('[data-rv2-filter="all"]');
    if (allBtn) allBtn.setAttribute('aria-pressed', 'true');

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        if (!state.hasMore || state.loading) return;
        state.page += 1;
        fetchPage(false);
      });
    }

    /* Per-tier "Виж всички" buttons → open the shared reviews modal filtered by tier.
       Heading override comes from the button's data-rv2-modal-heading attribute. */
    if (starsMoreBtn) {
      starsMoreBtn.addEventListener('click', function () {
        openReviewsModal('stars', starsMoreBtn.getAttribute('data-rv2-modal-heading'));
      });
    }
    if (textMoreBtn) {
      textMoreBtn.addEventListener('click', function () {
        openReviewsModal('text', textMoreBtn.getAttribute('data-rv2-modal-heading'));
      });
    }

    /* ────── Photos modal - gallery of ALL photo reviews + load more ────── */

    function renderPhotoTile(r) {
      // Video-first tile: if review has video, show poster + play overlay; else show first picture.
      var firstVid = r.videos && r.videos[0];
      var pic = r.pictures && r.pictures[0];
      var li = document.createElement('li');
      li.setAttribute('data-rv2-photo-tile', '');
      if (r.id) li.setAttribute('data-rv-id', r.id);
      var mediaHtml;
      if (firstVid) {
        // Perf: use poster as <img>; video bytes only load when user opens the detail modal.
        if (firstVid.poster) {
          mediaHtml = '<img src="' + escapeHtml(firstVid.poster) + '" alt="" loading="lazy">';
        } else {
          // No poster yet - render video with preload="none" so zero bytes load until interaction.
          mediaHtml = '<video preload="none" muted playsinline><source src="' + escapeHtml(firstVid.url) + '#t=0.1" type="video/mp4"></video>';
        }
        mediaHtml += '<span class="rv2__tile-play" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor" width="34" height="34"><path d="M8 5v14l11-7z"/></svg></span>';
      } else if (pic) {
        mediaHtml = '<img src="' + escapeHtml(pic.thumb || pic.full) + '" alt="" loading="lazy">';
      } else {
        mediaHtml = '';
      }
      li.innerHTML =
        mediaHtml +
        '<div class="rv2__photo-overlay">' +
          '<span class="rv2__photo-overlay-name">' + escapeHtml(r.reviewer_name) + '</span>' +
          '<span class="rv2__photo-overlay-stars">' + starsHtml(r.rating) + '</span>' +
        '</div>';
      // Click is handled by the global detail-modal delegation via [data-rv-id].
      return li;
    }

    function renderPhotosGrid() {
      if (!photosGrid) return;
      // Media gallery - includes any review with a video OR pictures. Sort: videos first (sort_order=0 hint).
      var photoReviews = state.allReviews.filter(function (r) { return hasMedia(r); }).sort(function (a, b) {
        var av = (a.videos && a.videos.length > 0) ? 0 : 1;
        var bv = (b.videos && b.videos.length > 0) ? 0 : 1;
        return av - bv;
      });
      photosGrid.innerHTML = '';
      if (photoReviews.length === 0) {
        photosEmptyEl.removeAttribute('hidden');
        photosLoadmoreEl.setAttribute('hidden', '');
        return;
      }
      photosEmptyEl.setAttribute('hidden', '');
      photoReviews.forEach(function (r) { photosGrid.appendChild(renderPhotoTile(r)); });
      // Show load-more in modal if main page also has more
      if (state.hasMore) photosLoadmoreEl.removeAttribute('hidden');
      else photosLoadmoreEl.setAttribute('hidden', '');
    }

    function openPhotosModal() {
      if (!photosModal) return;
      stopCarouselAutoplay();
      renderPhotosGrid();
      photosModal.removeAttribute('hidden');
      document.body.classList.add('rv2-modal-open');
    }
    function closePhotosModal() {
      if (!photosModal) return;
      photosModal.setAttribute('hidden', '');
      document.body.classList.remove('rv2-modal-open');
      startCarouselAutoplay();
    }
    photosModalCloseEls.forEach(function (el) { el.addEventListener('click', closePhotosModal); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && photosModal && !photosModal.hasAttribute('hidden')) closePhotosModal();
    });

    if (photosLoadmoreBtn) {
      photosLoadmoreBtn.addEventListener('click', function () {
        if (!state.hasMore || state.loading) return;
        photosLoadmoreBtn.setAttribute('aria-busy', 'true');
        state.page += 1;
        fetchPage(false).then(function () {
          renderPhotosGrid();
          photosLoadmoreBtn.removeAttribute('aria-busy');
        });
      });
    }

    /* ────── Reviews modal - filtered by tier (text/stars/all) + internal load-more ────── */

    var reviewsModalTitleEl = rv2.querySelector('[data-rv2-reviews-modal-title]');
    var reviewsModalSubEl = rv2.querySelector('[data-rv2-reviews-modal-sub]');

    function reviewsForMode(mode) {
      var buckets = bucketize(state.allReviews);
      if (mode === 'text') return buckets.text;
      if (mode === 'stars') return buckets.stars;
      return state.allReviews; // all
    }

    function renderReviewsModal() {
      if (!reviewsGridEl) return;
      reviewsGridEl.innerHTML = '';
      var reviews = reviewsForMode(state.modalMode);
      if (reviews.length === 0) {
        if (reviewsEmptyEl) reviewsEmptyEl.removeAttribute('hidden');
        if (reviewsLoadmoreEl) reviewsLoadmoreEl.setAttribute('hidden', '');
        return;
      }
      if (reviewsEmptyEl) reviewsEmptyEl.setAttribute('hidden', '');
      // Modal-internal pagination - show first state.modalVisible reviews; "Зареди още" reveals more
      var visible = reviews.slice(0, state.modalVisible);
      visible.forEach(function (r) {
        // Reuse text card renderer - works for star-only too (body just won't render if empty)
        reviewsGridEl.appendChild(renderTextCard(r));
      });
      // Show modal load-more if more reviews are loaded locally OR server still has pages
      var hasLocalMore = reviews.length > state.modalVisible;
      if (reviewsLoadmoreEl) {
        if (hasLocalMore || state.hasMore) reviewsLoadmoreEl.removeAttribute('hidden');
        else reviewsLoadmoreEl.setAttribute('hidden', '');
      }
    }

    /* Auto-paginate fetch loop - keeps fetching pages until server says no more.
       Re-renders the modal grid after each page so the user sees reviews appear progressively. */
    function autoLoadAllPages(maxPages) {
      maxPages = maxPages || 30;
      var fetched = 0;
      function loop() {
        if (!state.hasMore) return Promise.resolve();
        if (state.loading) {
          // Wait for any in-flight fetch then retry
          return new Promise(function (res) { setTimeout(res, 120); }).then(loop);
        }
        if (fetched >= maxPages) return Promise.resolve();
        state.page += 1;
        return fetchPage(false).then(function () {
          fetched++;
          if (reviewsModal && !reviewsModal.hasAttribute('hidden')) {
            renderReviewsModal();
          }
          return loop();
        });
      }
      return loop();
    }

    function openReviewsModal(mode, headingOverride) {
      if (!reviewsModal) return;
      state.modalMode = mode || 'all';
      // Reset modal pagination - show first batch on each open
      state.modalVisible = state.modalStep;
      // Update modal title - use override (from button data-attr) or fall back to default
      if (reviewsModalTitleEl) {
        var fallback = reviewsModalTitleEl.dataset.defaultTitle || reviewsModalTitleEl.textContent;
        reviewsModalTitleEl.textContent = headingOverride || fallback;
      }
      stopCarouselAutoplay();
      renderReviewsModal();
      reviewsModal.removeAttribute('hidden');
      document.body.classList.add('rv2-modal-open');
    }
    function closeReviewsModal() {
      if (!reviewsModal) return;
      reviewsModal.setAttribute('hidden', '');
      document.body.classList.remove('rv2-modal-open');
      state.modalMode = 'all';
      startCarouselAutoplay();
    }
    if (viewallBtn) viewallBtn.addEventListener('click', function () { openReviewsModal('all'); });
    reviewsModalCloseEls.forEach(function (el) { el.addEventListener('click', closeReviewsModal); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && reviewsModal && !reviewsModal.hasAttribute('hidden')) closeReviewsModal();
    });

    /* Modal-internal "Зареди още" - reveals next batch from already-loaded reviews,
       falls back to fetching another API page if local data is exhausted. */
    if (reviewsLoadmoreBtn) {
      reviewsLoadmoreBtn.addEventListener('click', function () {
        if (state.loading) return;
        var reviews = reviewsForMode(state.modalMode);
        if (reviews.length > state.modalVisible) {
          // Reveal next local batch
          state.modalVisible += state.modalStep;
          renderReviewsModal();
        } else if (state.hasMore) {
          // Local exhausted - fetch next API page, then reveal
          reviewsLoadmoreBtn.setAttribute('aria-busy', 'true');
          state.modalVisible += state.modalStep;
          state.page += 1;
          fetchPage(false).then(function () {
            renderReviewsModal();
            reviewsLoadmoreBtn.removeAttribute('aria-busy');
          });
        }
      });
    }

    /* ────── Modal ────── */
    var modal = rv2.querySelector('[data-rv2-modal]');
    var openBtn = rv2.querySelector('[data-rv2-open-modal]');
    var closeEls = rv2.querySelectorAll('[data-rv2-modal-close]');
    var form = rv2.querySelector('[data-rv2-form]');
    var submitBtn = rv2.querySelector('[data-rv2-submit]');
    var formError = rv2.querySelector('[data-rv2-form-error]');
    var modalBody = rv2.querySelector('[data-rv2-modal-body]');
    var successEl = rv2.querySelector('[data-rv2-success]');
    var successMsg = rv2.querySelector('[data-rv2-success-msg]');
    var successCode = rv2.querySelector('[data-rv2-success-code]');
    var successCodeVal = rv2.querySelector('[data-rv2-copy-code]');
    var successCodeMeta = rv2.querySelector('[data-rv2-success-code-meta]');

    function openModal() {
      if (!modal) return;
      modal.removeAttribute('hidden');
      document.body.classList.add('rv2-modal-open');
      if (modalBody) modalBody.removeAttribute('hidden');
      if (successEl) successEl.setAttribute('hidden', '');
    }
    function closeModal() {
      if (!modal) return;
      modal.setAttribute('hidden', '');
      document.body.classList.remove('rv2-modal-open');
    }
    if (openBtn) openBtn.addEventListener('click', openModal);
    /* Auto-open the write-review modal when arriving via #napishi-revyu (raffle banners). */
    if (modal && location.hash === '#napishi-revyu') { setTimeout(openModal, 350); }
    closeEls.forEach(function (el) { el.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) closeModal();
    });

    var ratingStars = rv2.querySelectorAll('[data-rv2-rating]');
    var ratingInput = form ? form.querySelector('input[name="rating"]') : null;
    var currentRating = 0;
    function paintStars(active) {
      ratingStars.forEach(function (s) {
        var n = parseInt(s.getAttribute('data-rv2-rating'));
        s.classList.toggle('is-on', n <= active);
      });
    }
    ratingStars.forEach(function (star) {
      var n = parseInt(star.getAttribute('data-rv2-rating'));
      star.addEventListener('mouseenter', function () { paintStars(n); });
      star.addEventListener('mouseleave', function () { paintStars(currentRating); });
      star.addEventListener('click', function () {
        currentRating = n;
        if (ratingInput) ratingInput.value = String(n);
        paintStars(n);
      });
    });

    var photoInput = rv2.querySelector('[data-rv2-photo-input]');
    var photoDrop = rv2.querySelector('[data-rv2-photo-drop]');
    var photoPlaceholder = rv2.querySelector('[data-rv2-photo-placeholder]');
    var photoPreview = rv2.querySelector('[data-rv2-photo-preview]');
    var photoImg = rv2.querySelector('[data-rv2-photo-img]');
    var photoRemove = rv2.querySelector('[data-rv2-photo-remove]');

    function showPhoto(file) {
      if (!file) return;
      if (file.size > 8 * 1024 * 1024) {
        showError('Снимката е твърде голяма (макс 8 MB).');
        photoInput.value = '';
        return;
      }
      var reader = new FileReader();
      reader.onload = function (e) {
        photoImg.src = e.target.result;
        photoPlaceholder.setAttribute('hidden', '');
        photoPreview.removeAttribute('hidden');
      };
      reader.readAsDataURL(file);
    }

    if (photoInput) {
      photoInput.addEventListener('change', function () {
        if (photoInput.files && photoInput.files[0]) showPhoto(photoInput.files[0]);
      });
    }
    if (photoRemove) {
      photoRemove.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        photoInput.value = '';
        photoImg.src = '';
        photoPreview.setAttribute('hidden', '');
        photoPlaceholder.removeAttribute('hidden');
      });
    }
    if (photoDrop) {
      ['dragenter', 'dragover'].forEach(function (ev) {
        photoDrop.addEventListener(ev, function (e) { e.preventDefault(); photoDrop.classList.add('is-drag'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        photoDrop.addEventListener(ev, function (e) { e.preventDefault(); photoDrop.classList.remove('is-drag'); });
      });
      photoDrop.addEventListener('drop', function (e) {
        var f = e.dataTransfer.files && e.dataTransfer.files[0];
        if (f && f.type.startsWith('image/')) {
          var dt = new DataTransfer();
          dt.items.add(f);
          photoInput.files = dt.files;
          showPhoto(f);
        }
      });
    }

    // ─── Video upload (separate field, same UX as photo) ───
    /* ─── Client-side video compression (PSI / UX fix) ───
       Big phone-recorded videos (HEVC/H.264, 80-150 MB) hit Cloudflare Workers'
       ~100 MB request-body cap → fetch fails with "Failed to fetch". Re-encode
       via MediaRecorder + captureStream at 1.5 Mbps, max 90s → ~17 MB output. */
    function setRv2Busy(text) {
      if (!submitBtn) return;
      if (text) {
        if (submitBtn.dataset.rv2BusyOrig === undefined) {
          submitBtn.dataset.rv2BusyOrig = submitBtn.innerHTML;
        }
        submitBtn.textContent = text;
        submitBtn.setAttribute('disabled', '');
      } else {
        if (submitBtn.dataset.rv2BusyOrig !== undefined) {
          submitBtn.innerHTML = submitBtn.dataset.rv2BusyOrig;
          delete submitBtn.dataset.rv2BusyOrig;
        }
        submitBtn.removeAttribute('disabled');
      }
    }
    function compressVideo(file) {
      return new Promise(function (resolve, reject) {
        try {
          if (!window.MediaRecorder || typeof HTMLVideoElement.prototype.captureStream !== 'function') {
            reject(new Error('Този браузър не може автоматично да компресира видеото. Опитай с по-кратко видео (под 60 сек) или в по-ниско качество.'));
            return;
          }
          var candidates = ['video/mp4', 'video/webm;codecs=vp9', 'video/webm;codecs=vp8', 'video/webm'];
          var mime = null;
          for (var i = 0; i < candidates.length; i++) {
            if (MediaRecorder.isTypeSupported(candidates[i])) { mime = candidates[i]; break; }
          }
          if (!mime) {
            reject(new Error('Браузърът не поддържа автоматична компресия. Опитай с по-кратко видео.'));
            return;
          }
          var video = document.createElement('video');
          video.muted = true;
          video.playsInline = true;
          video.preload = 'auto';
          var url = URL.createObjectURL(file);
          video.src = url;
          var MAX_DUR = 120;           // sec - auto-trim long clips
          var MAX_SIDE = 720;          // px - downscale longest side
          var TARGET_VBR = 900000;     // 0.9 Mbps video
          var TARGET_ABR = 80000;      // 80 kbps audio  → ~15 MB worst case
          var SIZE_GUARD = 90 * 1024 * 1024;  // post-compress sanity cap
          var progressTimer = null;
          var rafId = null;
          var cleanup = function () {
            try { URL.revokeObjectURL(url); } catch (e) {}
            if (progressTimer) { clearInterval(progressTimer); progressTimer = null; }
            if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
          };
          video.addEventListener('loadedmetadata', function () {
            var dur = isFinite(video.duration) && video.duration > 0 ? video.duration : MAX_DUR;
            var clipDur = Math.min(dur, MAX_DUR);
            var origW = video.videoWidth || 1280;
            var origH = video.videoHeight || 720;
            var scale = Math.min(1, MAX_SIDE / Math.max(origW, origH));
            var tw = Math.max(2, Math.round(origW * scale / 2) * 2);
            var th = Math.max(2, Math.round(origH * scale / 2) * 2);
            var canvas = document.createElement('canvas');
            canvas.width = tw; canvas.height = th;
            var ctx = canvas.getContext('2d');
            var combined;
            try {
              var srcStream = video.captureStream();
              var canvasStream = canvas.captureStream(30);
              combined = new MediaStream();
              canvasStream.getVideoTracks().forEach(function (t) { combined.addTrack(t); });
              srcStream.getAudioTracks().forEach(function (t) { combined.addTrack(t); });
            } catch (e) {
              cleanup(); reject(new Error('Браузърът не може да чете видеото за компресия.')); return;
            }
            var rec;
            try {
              rec = new MediaRecorder(combined, {
                mimeType: mime,
                videoBitsPerSecond: TARGET_VBR,
                audioBitsPerSecond: TARGET_ABR
              });
            } catch (e) {
              cleanup(); reject(new Error('Грешка при стартиране на компресия.')); return;
            }
            var chunks = [];
            rec.ondataavailable = function (ev) { if (ev.data && ev.data.size) chunks.push(ev.data); };
            rec.onerror = function () { cleanup(); reject(new Error('Грешка при компресия на видеото.')); };
            rec.onstop = function () {
              cleanup();
              var outType = (mime.split(';')[0]) || 'video/webm';
              var blob = new Blob(chunks, { type: outType });
              if (blob.size > SIZE_GUARD) {
                reject(new Error('Видеото е твърде дълго/тежко дори след компресия. Опитай с по-кратко видео (под 60 сек).'));
                return;
              }
              var ext = outType.indexOf('mp4') > -1 ? 'mp4' : 'webm';
              var base = (file.name || 'video').replace(/\.[^.]+$/, '');
              try {
                resolve(new File([blob], base + '_compressed.' + ext, { type: outType }));
              } catch (e) { resolve(blob); }
            };
            var drawLoop = function () {
              if (video.paused || video.ended) return;
              try { ctx.drawImage(video, 0, 0, tw, th); } catch (e) {}
              rafId = requestAnimationFrame(drawLoop);
            };
            var startTime = Date.now();
            progressTimer = setInterval(function () {
              var elapsed = (Date.now() - startTime) / 1000;
              var pct = Math.min(99, Math.round((elapsed / clipDur) * 100));
              setRv2Busy('Компресирам видеото… ' + pct + '%');
            }, 500);
            rec.start();
            var playPromise = video.play();
            var safeStart = function () { drawLoop(); };
            if (playPromise && typeof playPromise.then === 'function') {
              playPromise.then(safeStart).catch(function () {
                cleanup();
                try { rec.stop(); } catch (e2) {}
                reject(new Error('Не можах да възпроизведа видеото за компресия. Опитай с друг формат.'));
              });
            } else { safeStart(); }
            var hardStop = setTimeout(function () {
              try { rec.stop(); video.pause(); } catch (e) {}
            }, (clipDur + 0.4) * 1000);
            video.addEventListener('ended', function () {
              clearTimeout(hardStop);
              try { rec.stop(); } catch (e) {}
            });
          });
          video.addEventListener('error', function () {
            cleanup();
            reject(new Error('Не можах да прочета видеото. Опитай с друг формат (mp4 / mov).'));
          });
        } catch (e) { reject(e); }
      });
    }

    var videoInput = rv2.querySelector('[data-rv2-video-input]');
    var videoDrop = rv2.querySelector('[data-rv2-video-drop]');
    var videoPlaceholder = rv2.querySelector('[data-rv2-video-placeholder]');
    var videoPreview = rv2.querySelector('[data-rv2-video-preview]');
    var videoEl = rv2.querySelector('[data-rv2-video-el]');
    var videoRemove = rv2.querySelector('[data-rv2-video-remove]');

    function showVideo(file) {
      if (!file) return;
      // No hard size cap - large videos get auto-compressed before upload.
      // Use URL.createObjectURL (much faster than data URL for big videos)
      try { URL.revokeObjectURL(videoEl.src); } catch (e) {}
      videoEl.src = URL.createObjectURL(file);
      videoPlaceholder.setAttribute('hidden', '');
      videoPreview.removeAttribute('hidden');
    }

    if (videoInput) {
      videoInput.addEventListener('change', function () {
        if (videoInput.files && videoInput.files[0]) showVideo(videoInput.files[0]);
      });
    }
    if (videoRemove) {
      videoRemove.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        videoInput.value = '';
        try { URL.revokeObjectURL(videoEl.src); } catch (er) {}
        videoEl.removeAttribute('src');
        videoEl.load();
        videoPreview.setAttribute('hidden', '');
        videoPlaceholder.removeAttribute('hidden');
      });
    }
    if (videoDrop) {
      ['dragenter', 'dragover'].forEach(function (ev) {
        videoDrop.addEventListener(ev, function (e) { e.preventDefault(); videoDrop.classList.add('is-drag'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        videoDrop.addEventListener(ev, function (e) { e.preventDefault(); videoDrop.classList.remove('is-drag'); });
      });
      videoDrop.addEventListener('drop', function (e) {
        var f = e.dataTransfer.files && e.dataTransfer.files[0];
        if (f && f.type.startsWith('video/')) {
          var dt = new DataTransfer();
          dt.items.add(f);
          videoInput.files = dt.files;
          showVideo(f);
        }
      });
    }

    function showError(msg) {
      if (!formError) return;
      formError.textContent = msg;
      formError.innerHTML = '';
      formError.appendChild(document.createTextNode(msg));
      formError.removeAttribute('hidden');
    }
    function hideError() { if (formError) formError.setAttribute('hidden', ''); }

    // Inline email-typo suggestion - renders a clickable correction so the user
    // can fix common typos like "gmail.vom → gmail.com" with one tap.
    function showEmailSuggestion(inputEl, suggested) {
      if (!formError) return;
      formError.innerHTML = '';
      var msg = document.createElement('span');
      msg.textContent = 'Може би искаше да напишеш: ';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rv2__email-fix-btn';
      btn.textContent = suggested;
      btn.addEventListener('click', function () {
        if (inputEl) {
          inputEl.value = suggested;
          inputEl.focus();
        }
        hideError();
      });
      var hint = document.createElement('span');
      hint.className = 'rv2__email-fix-hint';
      hint.textContent = ' (натисни за корекция)';
      formError.appendChild(msg);
      formError.appendChild(btn);
      formError.appendChild(hint);
      formError.removeAttribute('hidden');
    }

    // ─── Email validation + typo suggestion (mirrors server-side validateEmail).
    //     TLD typos + explicit domain-typo table - no fuzzy matching (avoids false positives).
    var TLD_TYPOS = {
      vom: 'com', xom: 'com', con: 'com', cmo: 'com', coom: 'com', comm: 'com',
      dom: 'com', fom: 'com', gom: 'com', kom: 'com', cim: 'com', clm: 'com',
      ckm: 'com', coj: 'com', cob: 'com', cm: 'com', om: 'com', ocm: 'com',
      bgg: 'bg', bb: 'bg', bgr: 'bg', gb: 'bg', bvg: 'bg', bf: 'bg', bh: 'bg',
      nett: 'net', nrt: 'net', met: 'net', bet: 'net', nwt: 'net', ent: 'net', ne: 'net',
      ogr: 'org', orgg: 'org', ogt: 'org', orh: 'org', org0: 'org', rog: 'org',
      ue: 'eu', wu: 'eu', ru: 'eu', ei: 'eu',
      iio: 'io', oi: 'io', ip: 'io', ko: 'io',
      ed: 'de', fe: 'de', se: 'de', dr: 'de',
      ku: 'uk', yk: 'uk', uj: 'uk', ul: 'uk',
      rf: 'fr', fd: 'fr',
      ti: 'it', ot: 'it', ut: 'it',
      ws: 'es', rs: 'es',
      inf: 'info', niof: 'info', boz: 'biz', biz0: 'biz'
    };
    var DOMAIN_TYPOS = {
      'gmial.com': 'gmail.com', 'gnail.com': 'gmail.com', 'gmsil.com': 'gmail.com',
      'gmaill.com': 'gmail.com', 'gmal.com': 'gmail.com', 'gmali.com': 'gmail.com',
      'gmaol.com': 'gmail.com', 'gemail.com': 'gmail.com', 'gmsail.com': 'gmail.com',
      'gmail.co': 'gmail.com', 'gmaii.com': 'gmail.com', 'gnail.bg': 'gmail.com',
      'gimail.com': 'gmail.com', 'gmali.bg': 'gmail.com',
      'yhoo.com': 'yahoo.com', 'yaoo.com': 'yahoo.com', 'yahho.com': 'yahoo.com',
      'yhaoo.com': 'yahoo.com', 'yahooo.com': 'yahoo.com', 'yaho.com': 'yahoo.com',
      'tahoo.com': 'yahoo.com',
      'hotnail.com': 'hotmail.com', 'hotmial.com': 'hotmail.com', 'hotmali.com': 'hotmail.com',
      'htomail.com': 'hotmail.com', 'hotmaill.com': 'hotmail.com', 'hotmal.com': 'hotmail.com',
      'hotmaim.com': 'hotmail.com', 'htmail.com': 'hotmail.com', 'hotmsil.com': 'hotmail.com',
      'outlok.com': 'outlook.com', 'outloook.com': 'outlook.com', 'outluk.com': 'outlook.com',
      'outloo.com': 'outlook.com', 'outluck.com': 'outlook.com', 'utlook.com': 'outlook.com',
      'iclud.com': 'icloud.com', 'icoud.com': 'icloud.com', 'icould.com': 'icloud.com',
      'iclou.com': 'icloud.com', 'icloudd.com': 'icloud.com',
      'liv.com': 'live.com', 'livr.com': 'live.com', 'livee.com': 'live.com',
      'lieve.com': 'live.com', 'liev.com': 'live.com',
      'protomail.com': 'protonmail.com', 'protnmail.com': 'protonmail.com',
      'protnomail.com': 'protonmail.com', 'protonmial.com': 'protonmail.com',
      'protonmaill.com': 'protonmail.com', 'protomnail.com': 'protonmail.com',
      'mee.com': 'me.com', 'mr.com': 'me.com',
      'avb.bg': 'abv.bg', 'abvv.bg': 'abv.bg', 'abc.bg': 'abv.bg', 'aby.bg': 'abv.bg',
      'bav.bg': 'abv.bg',
      'mial.bg': 'mail.bg', 'nail.bg': 'mail.bg', 'maill.bg': 'mail.bg',
      'mial.com': 'mail.com',
      'dirr.bg': 'dir.bg', 'idr.bg': 'dir.bg', 'ddir.bg': 'dir.bg'
    };
    function validateEmailClient(raw) {
      var email = (raw || '').trim().toLowerCase();
      if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email)) return { valid: false };
      var atIdx = email.indexOf('@');
      var local = email.slice(0, atIdx);
      var domain = email.slice(atIdx + 1);
      if (DOMAIN_TYPOS[domain]) {
        return { valid: false, suggestion: local + '@' + DOMAIN_TYPOS[domain] };
      }
      var parts = domain.split('.');
      var lastTld = parts[parts.length - 1];
      if (TLD_TYPOS[lastTld]) {
        var fixed = parts.slice(0, -1).join('.') + '.' + TLD_TYPOS[lastTld];
        return { valid: false, suggestion: local + '@' + fixed };
      }
      return { valid: true };
    }

    /* Видеото НЕ тръгва към Judge.me (на нашия план не се публикува и се
       губеше мълчаливо). Качва се отделно при нас като история - гледаме го
       за реклами. Пуска се СЛЕД успешното ревю: ако то се провали, няма
       смисъл да качваме видео към несъществуващо ревю. */
    function sendVideoToUs(file, vName, vEmail, vBody) {
      var vfd = new FormData();
      vfd.append('name', vName || 'Клиент');
      vfd.append('email', vEmail || '');
      vfd.append('story', vBody || 'Видео към ревю.');
      vfd.append('consent', '1');
      vfd.append('source', 'review');
      vfd.append('subject_prefix', '[ВИДЕО ОТ РЕВЮ]');
      vfd.append('source_page', location.href);
      vfd.append('video', file, file.name || 'video.mp4');
      return fetch(workerBase + '/api/forms/real-moments', { method: 'POST', body: vfd })
        .catch(function (err) { console.error('[rv2] video upload failed:', err); });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        hideError();
        if (!currentRating) { showError('Избери оценка от 1 до 5 звезди.'); return; }

        // Client-side email check - surfaces typo suggestions inline before submitting.
        var emailInput = form.querySelector('input[name="reviewer_email"]');
        var emailVal = emailInput ? emailInput.value : '';
        var emailCheck = validateEmailClient(emailVal);
        if (!emailCheck.valid) {
          if (emailCheck.suggestion) {
            // Show suggestion inline + auto-fill on click (one-tap fix).
            showEmailSuggestion(emailInput, emailCheck.suggestion);
          } else {
            showError('Невалиден имейл адрес. Провери дали си го написал/а правилно.');
          }
          return;
        }

        // Продуктът е задължителен - без него ревюто увисва като „магазинно"
        // и не се показва на нито една продуктова страница (87 от първите 100
        // ревюта завършиха точно така).
        var ppHandle = (ppHidden && ppHidden.value || '').trim();
        if (!ppHandle) {
          showError('Избери за кой продукт е ревюто.');
          return;
        }

        if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');

        // Снимката се пази за Judge.me; тези три са за отделното качване на видео.
        var vName = (form.querySelector('input[name="reviewer_name"]') || {}).value || '';
        var vEmail = emailVal;
        var vBody = (form.querySelector('textarea[name="body"]') || {}).value || '';

        var rv2VideoFile = (videoInput && videoInput.files && videoInput.files[0]) || null;
        var rv2FinalVideo = rv2VideoFile;
        var rv2CompressPromise;
        // Таванът на една KV стойност е 25MB - компресията сваля до ~15MB.
        if (rv2VideoFile && rv2VideoFile.size > 15 * 1024 * 1024) {
          setRv2Busy('Компресирам видеото… 0%');
          rv2CompressPromise = compressVideo(rv2VideoFile);
        } else {
          rv2CompressPromise = Promise.resolve(rv2VideoFile);
        }

        rv2CompressPromise
          .then(function (finalVideo) {
            setRv2Busy('');
            rv2FinalVideo = finalVideo || null;
            var fd = new FormData(form);
            fd.delete('video'); // видеото върви по своя път - виж sendVideoToUs
            return fetch(workerBase + '/api/public/reviews/submit', { method: 'POST', body: fd });
          })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (resp) {
            if (!resp.ok || !resp.data.success) {
              throw new Error(resp.data.error || 'Грешка при изпращане.');
            }
            if (rv2FinalVideo) sendVideoToUs(rv2FinalVideo, vName, vEmail, vBody);
            modalBody.setAttribute('hidden', '');
            successEl.removeAttribute('hidden');
            successMsg.textContent = resp.data.message || 'Благодарим за ревюто!';
            if (resp.data.discount && resp.data.discount.code) {
              successCode.removeAttribute('hidden');
              successCodeVal.textContent = resp.data.discount.code;
              successCodeVal.setAttribute('data-code', resp.data.discount.code);
              var expDate = resp.data.discount.expires_at ? new Date(resp.data.discount.expires_at).toLocaleDateString('bg-BG') : '';
              successCodeMeta.textContent = '−' + (resp.data.discount.pct || 15) + '% • Не се комбинира с други отстъпки • Валиден до ' + expDate;
            } else {
              successCode.setAttribute('hidden', '');
            }
            form.reset();
            if (ppReset) ppReset();
            currentRating = 0;
            paintStars(0);
            if (photoPreview) photoPreview.setAttribute('hidden', '');
            if (photoPlaceholder) photoPlaceholder.removeAttribute('hidden');
            if (videoPreview) videoPreview.setAttribute('hidden', '');
            if (videoPlaceholder) videoPlaceholder.removeAttribute('hidden');
            if (videoEl) { try { URL.revokeObjectURL(videoEl.src); } catch (er) {} videoEl.removeAttribute('src'); }
          })
          .catch(function (err) {
            console.error('[rv2] submit failed:', err);
            var msg = err && err.message ? err.message : 'Грешка при изпращане. Опитай по-късно.';
            if (/failed to fetch/i.test(msg)) {
              msg = 'Видеото е твърде голямо за качване. Опитай с по-кратко видео (под 60 сек) или го запиши в по-ниско качество.';
            }
            showError(msg);
          })
          .finally(function () {
            setRv2Busy('');
            if (submitBtn) submitBtn.removeAttribute('aria-busy');
          });
      });
    }

    if (successCodeVal) {
      successCodeVal.addEventListener('click', function () {
        var code = successCodeVal.getAttribute('data-code');
        if (!code || !navigator.clipboard) return;
        navigator.clipboard.writeText(code).then(function () {
          var orig = successCodeVal.textContent;
          successCodeVal.textContent = '✓ копирано!';
          setTimeout(function () { successCodeVal.textContent = orig; }, 1500);
        });
      });
    }

    /* ────── Product picker dropdown - lazy-loads products on first open ────── */
    var ppReset = null;
    var pp = rv2.querySelector('[data-rv2-product-picker]');
    if (pp) {
      var ppOpenBtn = pp.querySelector('[data-rv2-pp-open]');
      var ppPanel = pp.querySelector('[data-rv2-pp-panel]');
      var ppList = pp.querySelector('[data-rv2-pp-list]');
      var ppSearch = pp.querySelector('[data-rv2-pp-search]');
      var ppEmpty = pp.querySelector('[data-rv2-pp-empty]');
      var ppHidden = pp.querySelector('[data-rv2-pp-input]');
      var ppLabel = pp.querySelector('[data-rv2-pp-label]');
      var ppThumb = pp.querySelector('[data-rv2-pp-thumb]');
      var ppScopeBadge = rv2.querySelector('[data-rv2-pp-scope]');
      var ppEmailInput = form && form.querySelector('input[name="reviewer_email"]');
      var ppCache = null;
      var ppLoaded = false;
      var ppLastEmail = '';

      function ppOpen() {
        if (!ppPanel) return;
        ppPanel.removeAttribute('hidden');
        ppOpenBtn.setAttribute('aria-expanded', 'true');
        if (ppSearch) ppSearch.focus();
        if (!ppLoaded) ppLoadProducts();
      }
      function ppClose() {
        if (!ppPanel) return;
        ppPanel.setAttribute('hidden', '');
        ppOpenBtn.setAttribute('aria-expanded', 'false');
      }
      function ppToggle() {
        if (ppPanel.hasAttribute('hidden')) ppOpen(); else ppClose();
      }

      function ppRender(products) {
        ppList.innerHTML = '';
        products.forEach(function (p) {
          var li = document.createElement('li');
          li.className = 'rv2__pp-item';
          li.setAttribute('role', 'option');
          li.setAttribute('data-handle', p.handle);
          li.innerHTML =
            '<span class="rv2__pp-item-thumb">' +
              (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="" loading="lazy">' : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>') +
            '</span>' +
            '<span class="rv2__pp-item-title">' + escapeHtml(p.title) + '</span>';
          li.addEventListener('click', function () { ppSelect(p); });
          ppList.appendChild(li);
        });
        if (ppEmpty) {
          if (products.length === 0) ppEmpty.removeAttribute('hidden');
          else ppEmpty.setAttribute('hidden', '');
        }
      }
      function ppFilter(query) {
        if (!ppCache) return;
        var q = (query || '').trim().toLowerCase();
        if (!q) return ppRender(ppCache);
        var filtered = ppCache.filter(function (p) {
          return p.title.toLowerCase().indexOf(q) !== -1 || p.handle.toLowerCase().indexOf(q) !== -1;
        });
        ppRender(filtered);
      }
      function ppSelect(p) {
        ppHidden.value = p ? p.handle : '';
        if (p) {
          ppLabel.textContent = p.title;
          ppThumb.innerHTML = p.image ? '<img src="' + escapeHtml(p.image) + '" alt="">' : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>';
          pp.classList.add('is-selected');
        } else {
          ppLabel.textContent = 'Избери продукт';
          ppThumb.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>';
          pp.classList.remove('is-selected');
        }
        ppClose();
      }
      function ppLoadProducts() {
        if (ppLoaded) return;
        ppLoaded = true;
        ppList.innerHTML = '<li class="rv2__pp-loading">Зарежда...</li>';
        // Cache-bust per browser session - products list updates within a few minutes
        // (worker cache 5 min). Without this, browsers can hold stale results for hours.
        var cacheBust = Math.floor(Date.now() / (5 * 60 * 1000));
        var ppUrl = workerBase + '/api/public/reviews/products?_v=' + cacheBust;
        // С валиден имейл ендпойнтът връща САМО реално поръчаното от този
        // клиент (matched_email:true). Без съвпадение идва пълният списък -
        // никого не спираме да остави ревю.
        ppLastEmail = ppEmailInput ? (ppEmailInput.value || '').trim().toLowerCase() : '';
        if (/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(ppLastEmail)) {
          ppUrl += '&email=' + encodeURIComponent(ppLastEmail);
        }
        fetch(ppUrl)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            ppCache = data.products || [];
            if (ppScopeBadge) {
              if (data.matched_email) ppScopeBadge.removeAttribute('hidden');
              else ppScopeBadge.setAttribute('hidden', '');
            }
            ppRender(ppCache);
            // Pre-select if section provided product handle
            if (productHandle) {
              var match = ppCache.find(function (p) { return p.handle === productHandle; });
              if (match) ppSelect(match);
            }
          })
          .catch(function () {
            ppList.innerHTML = '<li class="rv2__pp-loading">Грешка при зареждане. Опитай по-късно.</li>';
            ppLoaded = false;
          });
      }

      ppReset = function () { ppSelect(null); };

      // Смяна на имейла → списъкът се презарежда за НОВИЯ клиент.
      if (ppEmailInput) {
        ppEmailInput.addEventListener('change', function () {
          var v = (ppEmailInput.value || '').trim().toLowerCase();
          if (v === ppLastEmail) return;
          ppLoaded = false;
          ppCache = null;
          ppSelect(null);
          ppLoadProducts();
        });
      }

      ppOpenBtn.addEventListener('click', ppToggle);
      if (ppSearch) ppSearch.addEventListener('input', function () { ppFilter(ppSearch.value); });
      // Click-outside closes
      document.addEventListener('click', function (e) {
        if (pp.contains(e.target)) return;
        if (!ppPanel.hasAttribute('hidden')) ppClose();
      });
      // Pre-load + pre-select if product context provided
      if (productHandle) ppLoadProducts();
    }

    fetchStats();
    fetchPage(true).then(function () {
      // In full mode (dedicated reviews page), background-fetch the remaining pages so
      // inline tier counts + "Виж всички (N)" badges reflect the true totals - instead of
      // just the first API page. Compact mode (product page embed) skips this for speed.
      if (!isCompact && state.hasMore) {
        autoLoadAllPages(30);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-rv2]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();


/* ═══════════════════════════════════════════════════════════════
   SINGLE-REVIEW DETAIL MODAL
   Click on any rendered .rv2__card[data-rv-id] → open modal with the
   full review content + photos. Lookup happens against the section's
   in-memory `state.allReviews` cache, exposed via window.__rv2State.
   Standalone IIFE that wires up event delegation per section.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  function escapeHtml(s) {
    return (s || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function escapeAttr(s) { return escapeHtml(s).replace(/`/g, '&#96;'); }
  function starsHtml(rating) {
    var full = Math.max(0, Math.min(5, parseInt(rating || 5)));
    var html = '';
    for (var i = 1; i <= 5; i++) html += i <= full ? '★' : '<span style="opacity:.25">★</span>';
    return html;
  }
  function formatDate(s) {
    if (!s) return '';
    try {
      var d = new Date(s);
      return d.toLocaleDateString('bg-BG', { year: 'numeric', month: 'long', day: 'numeric' });
    } catch (e) { return s; }
  }
  function renderDetail(r) {
    // Normalize pictures - API shape is [{full, thumb}, ...]; legacy may be strings.
    var pics = (r.pictures || r.photos || []).filter(Boolean).map(function (p) {
      if (typeof p === 'string') return { full: p, thumb: p };
      return { full: p.full || p.thumb || '', thumb: p.thumb || p.full || '' };
    }).filter(function (p) { return p.full || p.thumb; });
    var vids = (r.videos || []).filter(function (v) { return v && v.url; });

    // Video block - first, full-width. Auto-plays muted on open (browsers
    // allow muted autoplay everywhere) so the reviewer's energy carries through.
    var videosHtml = '';
    if (vids.length) {
      videosHtml = '<div class="rv2__detail-videos">';
      vids.forEach(function (v) {
        var poster = v.poster ? ' poster="' + escapeAttr(v.poster) + '"' : '';
        videosHtml += '<video class="rv2__detail-video" controls preload="metadata" playsinline' + poster + '>' +
          '<source src="' + escapeAttr(v.url) + '" type="video/mp4">' +
          'Браузърът ти не поддържа видео.' +
        '</video>';
      });
      videosHtml += '</div>';
    }

    // Photo grid - videos already rendered above; photos come below.
    var photos = '';
    if (pics.length) {
      photos = '<div class="rv2__detail-photos' + (pics.length === 1 && !vids.length ? ' rv2__detail-photos--single' : '') + '">';
      pics.forEach(function (p) {
        photos += '<img src="' + escapeAttr(p.full) + '" data-full="' + escapeAttr(p.full) + '" alt="" loading="lazy">';
      });
      photos += '</div>';
    }

    var stars = '<div class="rv2__detail-stars" aria-label="' + (r.rating || 5) + ' от 5 звезди">' + starsHtml(r.rating) + '</div>';
    var title = r.title ? '<h3 class="rv2__detail-title">' + escapeHtml(r.title) + '</h3>' : '';
    var body = r.body ? '<div class="rv2__detail-text">' + escapeHtml(r.body) + '</div>' : '';

    var bits = [];
    bits.push('<span class="rv2__detail-author"><strong>' + escapeHtml(r.reviewer_name || 'Анонимен') + '</strong></span>');
    bits.push('<span class="rv2__detail-date">' + formatDate(r.created_at) + '</span>');
    if (r.verified) bits.push('<span class="rv2__detail-verified">✓ Купувач</span>');
    // Skip Judge.me's "judgeme-shop-reviews" placeholder - that's a site-wide
    // shop review, not tied to any real product, and /products/judgeme-shop-reviews 404s.
    if (r.product_handle && r.product_handle !== 'judgeme-shop-reviews') {
      bits.push('<a class="rv2__detail-product" href="/products/' + escapeAttr(r.product_handle) + '">' + escapeHtml(r.product_title || 'Виж продукта') + '</a>');
    }
    var meta = '<div class="rv2__detail-meta">' + bits.join('') + '</div>';

    // Shop reply - rendered ONLY inside the detail modal, nowhere else (cards / carousel / gallery stay clean).
    var reply = '';
    if (r.reply) {
      reply = '<div class="rv2__detail-reply">' +
        '<div class="rv2__detail-reply-head">' +
          '<svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>' +
          '<span>Отговор от Wishifyy</span>' +
        '</div>' +
        '<div class="rv2__detail-reply-body">' + escapeHtml(r.reply) + '</div>' +
      '</div>';
    }

    return videosHtml + photos + stars + title + body + meta + reply + (window.__helpfulButtonHtml ? window.__helpfulButtonHtml(r.id) : '');
  }

  /* Keep body.rv2-modal-open in sync - only remove when NO rv2 modal remains open.
     Avoids prematurely unlocking page scroll when detail modal closes on top of
     an already-open photos / reviews modal (modal-over-modal flow). */
  function syncBodyModalOpen() {
    var anyOpen = !!document.querySelector(
      '[data-rv2-detail-modal]:not([hidden]),' +
      '[data-rv2-photos-modal]:not([hidden]),' +
      '[data-rv2-reviews-modal]:not([hidden]),' +
      '[data-rv2-modal]:not([hidden])'
    );
    document.body.classList.toggle('rv2-modal-open', anyOpen);
  }

  function openDetailModal(rv2Root, review) {
    var modal = rv2Root.querySelector('[data-rv2-detail-modal]');
    var body = rv2Root.querySelector('[data-rv2-detail-body]');
    if (!modal || !body) return;
    body.innerHTML = renderDetail(review);
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    syncBodyModalOpen();
  }
  function closeDetailModal(rv2Root) {
    var modal = rv2Root.querySelector('[data-rv2-detail-modal]');
    if (!modal) return;
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    syncBodyModalOpen();
  }

  function initDetail(rv2Root) {
    if (rv2Root.dataset.rvDetailInit === '1') return;
    rv2Root.dataset.rvDetailInit = '1';

    /* Helpful button click - vote + persist + update UI */
    rv2Root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rv2-helpful-btn]');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      var box = btn.closest('[data-rv2-helpful]');
      if (!box) return;
      var rid = box.getAttribute('data-rv2-helpful');
      if (!rid || btn.classList.contains('is-voted')) return;
      btn.classList.add('is-voted');
      var lbl = btn.querySelector('.rv2__helpful-label');
      if (lbl) lbl.textContent = 'Благодарим!';
      var workerBase = rv2Root.dataset.workerBase || 'https://wishifyy-crm.wishifycom.workers.dev';
      fetch(workerBase + '/api/public/reviews/' + encodeURIComponent(rid) + '/helpful', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ voter_token: (window.__rv2HelpfulToken ? window.__rv2HelpfulToken() : ('h_' + Math.random().toString(36).slice(2,14))) })
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (window.__rv2MarkVoted) window.__rv2MarkVoted(rid);
          if (d && typeof d.helpful_count === 'number' && d.helpful_count >= 1) {
            var n = d.helpful_count;
            var escId = window.__cssEscapeId ? window.__cssEscapeId(rid) : String(rid).replace(/[^a-zA-Z0-9_-]/g, "");
            var lblText = window.__helpfulCountText ? window.__helpfulCountText(n) : (n + (n === 1 ? ' човек' : ' човека'));
            document.querySelectorAll('[data-rv2-helpful="' + escId + '"] [data-rv2-helpful-count]').forEach(function (c) {
              c.textContent = lblText;
              c.removeAttribute('hidden');
            });
          }
        })
        .catch(function () {
          btn.classList.remove('is-voted');
          if (lbl) lbl.textContent = 'Полезно';
        });
    });

    // Click delegation - works on cards rendered now and later (state grows).
    rv2Root.addEventListener('click', function (e) {
      // Close
      if (e.target.closest('[data-rv2-detail-close]')) {
        closeDetailModal(rv2Root);
        return;
      }
      // Photo in detail modal → open full-size in new tab (lightbox-style zoom)
      var detailImg = e.target.closest('.rv2__detail-photos img');
      if (detailImg && detailImg.src) {
        window.open(detailImg.getAttribute('data-full') || detailImg.src, '_blank', 'noopener');
        return;
      }
      // Card click → open
      var card = e.target.closest('[data-rv-id]');
      if (!card) return;
      // Don't hijack clicks on links / buttons inside the card
      if (e.target.closest('a, button')) return;
      var id = card.getAttribute('data-rv-id');
      // Look up state using the SAME key fallback chain as where it was stored
      // (rv2.id || rv2.dataset.rv2Sid || 'default'). On the home page neither
      // an id nor data-rv2-sid is set on the section, so state lives under
      // 'default' - without this fallback the modal silently never opened.
      var stateKey = rv2Root.id || rv2Root.dataset.rv2Sid || 'default';
      var state = window.__rv2State && window.__rv2State[stateKey];
      // Defensive fallback - if multiple review sections coexist on the page,
      // also walk every cached state and try to find a matching review id.
      var review = state && (state.allReviews || []).find(function (r) {
        return String(r.id) === String(id);
      });
      if (!review && window.__rv2State) {
        var keys = Object.keys(window.__rv2State);
        for (var k = 0; k < keys.length && !review; k++) {
          var st = window.__rv2State[keys[k]];
          review = st && (st.allReviews || []).find(function (r) {
            return String(r.id) === String(id);
          });
        }
      }
      if (review) openDetailModal(rv2Root, review);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var modal = rv2Root.querySelector('[data-rv2-detail-modal]');
      if (modal && !modal.hasAttribute('hidden')) closeDetailModal(rv2Root);
    });
  }

  function initAllDetail() {
    document.querySelectorAll('[data-rv2]').forEach(initDetail);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllDetail);
  } else {
    initAllDetail();
  }
  document.addEventListener('shopify:section:load', initAllDetail);

  /* MutationObserver - when new cards render (load-more / page change),
     stamp data-rv-id on cards using their .rv2__card-id data attribute
     populated upstream by renderTextCard / renderStarOnlyCard via state. */
  var stampObserver = new MutationObserver(function () {
    document.querySelectorAll('.rv2__card:not([data-rv-id])').forEach(function (card) {
      var id = card.dataset.rvId || card.getAttribute('data-rv-id');
      if (id) card.setAttribute('data-rv-id', id);
    });
  });
  stampObserver.observe(document.body, { childList: true, subtree: true });
})();
